import { opts } from '../opts.js';
import { connectClearRefinements } from '../../../../dist/vendor/instantsearch.js/es/connectors/index.js';
import { parseTemplate } from '../util/helpers.js';


// only show clear button if 2+ refinements
const transformClear = items => items.length > 1
	? items
	: []

const renderClearRefinements = ({
	canRefine,
	refine,
	widgetParams: {
		container,
		text: { label },
		cssClasses: { root, list, button, text }
	}}, isFirstRender ) => {

	if (isFirstRender) {
		container.innerHTML = `
			<div class="${root}">
				<div class="${list}"></div>
			</div>
		`;
	}


	container.querySelector(`.${list}`)
		.innerHTML = parseTemplate( 'clearRefinements', {
			label,
			button,
			text,
		});


	const close = container.querySelector(`.${button}`);
	if (close) {
		close.disabled = !canRefine;
		close.addEventListener('click',
			({ target }) => refine(target.dataset.value)
		);
	}
};

export const config = {
	...opts.clearRefinements,
	transformItems(items) {
		return transformClear(items)
	}
};

export const widget = connectClearRefinements(renderClearRefinements);
